export default {
  common: {
    account: '계정',
    return: '돌아가기'
  },
  button: {
    returnTop: 'TOP으로 돌아가기',
    rangeSelect: '승차 구간・시간 선택하기',
    busSelect: '승차 버스 선택하기',
    reserveConfirm: '예약 확정',
    reserveCancel: '예약 취소'
  },
  view: {
    ticket: '승차권',
    fromAirport: '공항에서',
    toAirport: '공항으로',
    directionDep: '출발',
    directionDepDesc: '공항 → 목적지',
    directionArr: '도착',
    directionArrDesc: '목적지 → 공항',
    pleaseSelectBus: '버스를 선택하세요',
    availablePeriod: '이용 가능 기간',
    useInstruction: '이용 설명',
    adultCount: '성인 × {{count}}명',
    childCount: '어린이 × {{count}}명',
    disabledAdultCount: '장애인(성인) × {{count}}명',
    rangeAndSchedule: '승차 구간과 승차 예정일',
    pleaseSelect: '(을)를 선택해 주세요.',
    ridingDate: '승차일',
    ridingPlace: '출발지',
    departurePlace: '승차지',
    arrivalPlace: '도착지',
    company: '운행회사',
    availableSeatsCount: '공석 수',
    ridingBusTime: '승차 버스 시간',
    buyTicket: '승차권 구입',
    reservationRideInfo: '예약 승차 정보',
    inReserve: '예약 중',
    thankForReservation: '예약해 주셔서 감사합니다. ',
    reservationConfirmed: '아래 내용으로 예약이 확정되었습니다.',
    inCancel: '취소 중',
    cancelInfo: '취소 정보',
    isCanceled: '예약을 취소했습니다.',
    notAvailableBus:
      '"선택하신 구간과 승차 날짜에이용할 수 있는 버스가 없습니다."',
    currentJapanTime: '현재 일본 시간 : {{time}}',
    baseJapanTime: '하기 시간은 일본 시간을 기준으로 합니다.',
    remainsCount: '잔여 좌석 수'
  }
};
